<template src="./SideBar.html"></template>
<style lang="scss" scoped src="./SideBar.scss"></style>
<script>
export default {
  name: "SideBar",
  props: {
    isMobileSidebarOpen: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rol: "",
      nombreCompleto: String,
      correo: String,
    };
  },
  async created() {
    this.getUserInfo();
    this.checkRole();
  },
  methods: {
    getUserInfo() {
      this.nombreCompleto = localStorage
        ? localStorage.getItem("first_name") +
          " " +
          localStorage.getItem("last_name")
        : "";
      this.correo = localStorage?.getItem("email") || "";
    },
    checkRole() {
      this.rol = localStorage.getItem("role_name");
    },
    closeMobileSidebar() {
      this.$emit("sidebar-closed");
    },
    // Method to receive toggle from parent
    toggleSidebar() {
      // This method is called by parent to control sidebar state
      // The actual state is managed by the parent via props
    },
    goHome() {
      this.$router.push("/home");
      this.closeMobileSidebar();
    },
    goUsuarios() {
      this.$router.push("/usuarios");
      this.closeMobileSidebar();
    },
    goCursos() {
      this.$router.push("/cursos");
      this.closeMobileSidebar();
    },
    goMatricula() {
      this.$router.push("/matricula");
      this.closeMobileSidebar();
    },
    goMyProfile() {
      this.$router.push("/profile");
      this.closeMobileSidebar();
    },
    handleSignOut() {
      localStorage.clear();
      this.$router.go("/");
    },
    isActive(route) {
      return this.$route.path.includes(route);
    },
  },
};
</script>
